<button type="button" (click)="onBackClick()" [ngClass]="buttonNgClass" [disabled]="buttonDisabled" [innerHTML]="buttonHTML"></button>
